import { render, staticRenderFns } from "./RespuestasComponent.vue?vue&type=template&id=4545a8f2"
import script from "./RespuestasComponent.vue?vue&type=script&lang=js"
export * from "./RespuestasComponent.vue?vue&type=script&lang=js"
import style0 from "./RespuestasComponent.vue?vue&type=style&index=0&id=4545a8f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports